<template>
  <div class="col-lg-2 col-md-3  col-sm-6 statbox mb-4">
    <div :class="alarm ? 'active-06-statbox': ''">
      <div class="box">
        <span class="title widget-title" v-html="widget.attributes.paramDescription.attributeValue"></span>        
      </div>

      <div v-if="data.stringValue != undefined && ready">        
        <span class="widget-value" v-if="ready">
          <template v-if="data.value == widget.attributes.paramValueOpen.attributeValue">
            <img class="widget-06-img" :src="widget.attributes.imgUrlOpen.attributeValue">
            <span class="widget-06-value" v-html="widget.attributes.labelOpen.attributeValue"></span>
          </template>
          <template v-else-if="data.value == widget.attributes.paramValueClosed.attributeValue">
            <img class="widget-06-img" :src="widget.attributes.imgUrlClosed.attributeValue">
            <span class="widget-06-value" v-html="widget.attributes.labelClosed.attributeValue"></span>
          </template>
          <template v-else>
            <img class="widget-06-img" :src="widget.attributes.imgUrlDetached.attributeValue">
            <span class="widget-06-value" v-html="widget.attributes.labelDetached.attributeValue"></span>
          </template>
        </span>        
      </div>
      <div v-else class="text-center">
        <span class="widget-value" v-if="ready">
          <img class="widget-06-img" :src="widget.attributes.imgUrlDetached.attributeValue">
          <span class="widget-06-value">{{ "unhookedSwitch" | translate }}</span>
        </span>
        <span v-else></span>
      </div>

      <div class="widget-footer">
        <div>
          <template v-if="data.stringTimestamp != undefined">
            <div v-html="data.stringTimestamp[0] != undefined ? data.stringTimestamp[0]: ''"></div>
            <div v-html="data.stringTimestamp[1] != undefined ? data.stringTimestamp[1]: ''"></div>          
          </template>
        </div>
        <div>
          <a @click.prevent="openChart" class="eye">
            <img src="/assets/img/png/eye.png" alt="show-chart"/>
          </a>
        </div>
      </div>
    </div>

    <overlay :enabled="loading"></overlay>
  </div>
</template>

<script>
  import moment from 'moment'
  import notificator from '@/mixins/notificator';

  import Overlay from '@/components/Overlay.vue';
  
  export default {
    props: ['widget'],

    components: {Overlay},

    mixins: [notificator],

    data() {
      return {
        ready: false,
        loading: false,
        timer: null,
        data: {},

        alarm: false
      }
    },

    created() {      
      this.start();
    },

    methods: {
      start() {
        this.getTSData()

        this.timer = setInterval(() => {
            this.getTSData()
        }, 60000);
      },

      generateDevicesQueries() {
        var offset = new Date().getTimezoneOffset();

        return [{
          'aggregation': {
            'mode': 'LAST'
          },
          'aqDatetimeLowerbound': moment().subtract(1, 'days').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z',
          'aqDatetimeUpperbound': moment().add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z',
          'deviceIds': [this.widget.deviceId], 
          'paramIds': [parseInt(this.widget.attributes.paramId.attributeValue)],
          'queryId': 'LAST',
          'readingType': 'HOT'
        }]                 
      },

      getTSData() {

        if(!this.ready)
          this.overlay(true);

        this.$store
          .dispatch('getTSData', {devicesQueries: this.generateDevicesQueries()})
          .catch(error => {
            if(!this.ready)
              this.overlay(false);

            this.notify(this.$options.filters.notification({endpoint: 'GetTSData', code: error}));            

            this.data = {};

            if(!this.ready)
                this.ready = true;
          })
          .then(({data}) => {
            if(!this.ready)
              this.overlay(false);

            this.notify(this.$options.filters.notification({endpoint: 'GetTSData', code: 200}));

            if(data != undefined && data.deviceQueriesResponse != undefined && data.deviceQueriesResponse.LAST[0] != undefined) {
              if(data.deviceQueriesResponse.LAST[0].stringTimestamp != undefined)
                data.deviceQueriesResponse.LAST[0].stringTimestamp = data.deviceQueriesResponse.LAST[0].stringTimestamp.split(" ")
              
              this.data = data.deviceQueriesResponse.LAST[0];

              if(data.deviceQueriesResponse.LAST[0] != undefined && data.deviceQueriesResponse.LAST[0].isOld != undefined && data.deviceQueriesResponse.LAST[0].isOld)
                this.alarm = true;
              else 
                this.alarm = false;

              
            } else {
              this.data = {};
              this.alarm = true;
            }

            if(!this.ready)
                  this.ready = true;
        });          
      },

      openChart() {
          this.$emit('open-chart', this.widget);
      },

      overlay(action) {
        this.loading = action;
      }
    },

    beforeDestroy: function(){
      clearInterval(this.timer);
    }
  }
</script>

<style>
  .widget-06-img {
    width: 60px;
  }
  .widget-06-value {
    font-size: 18px;
    margin-left: 15px;
  }
</style>